<section id="main"
         class="bg-light">
     <div id="monthlyInvoicesReportContainer"
          class="container">
          <h1 [innerHtml]="'MonthlyInvoicesReport' | translator:'invoice'">Monthly Invoices</h1>

          <div class="overlay"
               *ngIf="isDownloading">
               <h1 class="heading"
                   [innerHtml]="'Loading' | translator:'base'">Loading ...</h1>
               <img [alt]="'Loading' | translator:'base'"
                    name="Loading" />
          </div>

          <div class="row">
               <div class="col-lg-8">
                    <div class="row gx-2">
                         <div class="col-12 mb-3">
                              <p [innerHtml]="'MonthlyInvoicesTxt' | translator:'invoice'">
                                   This option enables users to view and download their account's invoice for the
                                   billing cycle selected. <br><i>Note: If the billing cycle selected has not yet
                                        closed, the invoiced amounts are not final. The invoice will display the
                                        following message: "Invoice not final - Please check back later"</i>.
                              </p>
                         </div>
                         <div class="col-12 mb-3">
                              <div *ngIf="showNoInvoicesAlert"
                                   [ngClass]="'alert alert-success alert-dismissible fade ' + (showNoInvoicesAlert ? 'show' :'hide')"
                                   name="showNoInvoicesAlert"
                                   role="alert">
                                   <span [innerHtml]="'NoInvoicesFoundBody' | translator:'invoice'"
                                         [title]="'NoInvoicesFoundBody' | translator:'invoice'">
                                        There were no invoices found in the selected billing period.
                                   </span>
                                   <button type="button"
                                           class="btn-close"
                                           data-dismiss="alert"
                                           (click)="showNoInvoicesAlert=false"
                                           [ariaLabel]="'Close' | translator:'base'"
                                           [title]="'Close' | translator:'base'">
                                        <span class="visually-hidden">X</span>
                                   </button>
                              </div>
                              <div *ngIf="showInvoiceDownloadedAlert"
                                   [ngClass]="'alert alert-success alert-dismissible fade ' + (showInvoiceDownloadedAlert ? 'show' :'hide')"
                                   name="showInvoiceDownloadedAlert"
                                   role="alert">
                                   <span [innerHtml]="'showInvoiceDownloadedAlertBody1' | translator:'invoice'"
                                         [title]="'showInvoiceDownloadedAlertBody1' | translator:'invoice'">Invoice</span>:
                                   {{
                                        invoiceId }} <span
                                         [innerHtml]="'showInvoiceDownloadedAlertBody2' | translator:'invoice'"
                                         [title]="'showInvoiceDownloadedAlertBody2' | translator:'invoice'">was
                                        downloaded to
                                        your browser</span>
                                   <button type="button"
                                           class="btn-close"
                                           data-dismiss="alert"
                                           (click)="showInvoiceDownloadedAlert=false"
                                           [ariaLabel]="'Close' | translator:'base'"
                                           [title]="'Close' | translator:'base'">
                                        <span class="visually-hidden">X</span>
                                   </button>
                              </div>
                         </div>
                         <div class="col-12 mb-3">
                              <label for="billingPeriod"
                                     class="form-label">
                                   <span [innerHtml]="'billingPeriod' | translator:'invoice'">Billing Period (mm/yyyy)</span>:
                                   <span class="text-danger text-center ms-1"
                                         [title]="'Required' | translator:'base'">*</span>
                              </label>
                              <select class="form-select"
                                      name="billingPeriod"
                                      id="billingPeriod"
                                      [(ngModel)]="billingPeriod"
                                      (change)="clearInvoices()">
                                   <option *ngFor="let p of periodList; let index = index" [value]="p">
                                        {{ p.substring(0,2) }}/{{ p.substring(2, 6) }} 
                                        <span *ngIf="index === 0" [innerHtml]="'notFinal' | translator:'invoice'"> - NOT FINAL</span>
                                   </option>
                              </select>
                         </div>
                         <div class="col-12 mb-3"
                              *ngIf="billCycleInvoices && billCycleInvoices.length === 0">
                              <label for="invoiceId"
                                     class="form-label">
                                   <span [innerHtml]="'InvoiceId' | translator:'invoice'"></span>:
                              </label>
                              <input type="text"
                                     class="form-control"
                                     name="invoiceId"
                                     id="invoiceId"
                                     [(ngModel)]="invoiceId"
                                     [placeholder]="'InvoiceId' | translator:'invoice'" />
                         </div>
                         <div *ngIf="billCycleInvoices && billCycleInvoices.length > 0">
                              <div class="col-12 mb-3">
                                   <label for="invoiceId"
                                          class="form-label">
                                        <span [innerHtml]="'InvoiceId' | translator:'invoice'"></span>:
                                   </label>
                                   <select class="form-select"
                                           name="invoiceId"
                                           id="invoiceId"
                                           [(ngModel)]="invoiceId">
                                        <option *ngFor="let i of billCycleInvoices"
                                                [value]="i.invoiceId">{{ i.invoiceId
                                             }}</option>
                                   </select>
                              </div>
                         </div>
                         <div class="col-12 mb-3">
                              <label for="reportType" class="form-label">
                                   <span [innerHtml]="'outputFormat' | translator:'invoice'">
                                        Output Format: (This report is only available in PDF format):
                                   </span>
                              </label>
                         </div>
                         <div class="col-6 mb-3">
                              <button class="btn btn-primary btn-strong"
                                      [innerHtml]="'downloadReport' | translator:'invoice'"
                                      [title]="'downloadReport' | translator:'invoice'"
                                      (click)="downloadReport()"
                                      [disabled]="!pageValid()"
                                      id="downloadReport"
                                      name="downloadReport">
                                   Request Report</button>
                         </div>
                         <div class="col-6 mb-3">
                              <button routerLink="/billingReports"
                                      class="btn btn-secondary btn-strong"
                                      [innerHTML]="'returnBillingReports' | translator:'invoice'"
                                      [title]="'returnBillingReports' | translator:'invoice'">
                                   Return to Billing Reports
                              </button>
                         </div>
                    </div>
               </div>
               <div class="col-lg-4 order-lg-2 sidebar">
                    <app-dashboardsupport></app-dashboardsupport>
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <h2 class="card-title h5 mt-0"
                                  [innerHtml]="'Resources' | translator:'base'">Resources</h2>
                              <ul>
                                   <li *ngIf="companyType === 'MC'">
                                        <button (click)="openDocument('PSPMotorCarrierEnrollment')"
                                                target="_blank"
                                                class="btn btn-link"
                                                [title]="'MAHEnrollAgreement' | translator:'base'"
                                                [innerHtml]="'MAHEnrollAgreement' | translator:'base'"
                                                name="MAHagreement"
                                                id="MAHagreement">PSP Monthly Account Holder Enrollment Agreement
                                        </button>
                                   </li>
                                   <li *ngIf="companyType === 'ISP'">
                                        <button (click)="openDocument('ISPAccountHolderAgreement')"
                                                target="_blank"
                                                class="btn btn-link"
                                                [title]="'ISPEnrollAgreement' | translator:'base'"
                                                [innerHtml]="'ISPEnrollAgreement' | translator:'base'"
                                                name="ISPagreement"
                                                id="ISPagreement">PSP Industry Service Provider Enrollment Agreement
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                                [innerHtml]="'DisclosureAndAuth' | translator:'base'"
                                                (click)="openDocument('PSPDisclosureandAuthorizationForm')"
                                                target="_blank"
                                                [title]="'DisclosureAndAuth' | translator:'base'"
                                                name="dna"
                                                id="dna">Disclosure
                                             and Authorization Form
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                                (click)="openDocument('BillingGuide')"
                                                target="_blank"
                                                title="Billing Manual"
                                                name="billingmanual"
                                                id="billingmanual">Billing Manual
                                        </button>
                                   </li>
                              </ul>
                         </div>
                    </div>
               </div>
          </div>
     </div>
</section>